<ng-container>
  <div class="log-metadata">
    <div class="v-center" style="gap: 8px;">
      <div class="log-metadata-time">{{log.eventCreated}}</div>
      <div class="log-metadata-category">
        <div class="badge relay-background">Manual Relay Event</div>
      </div>
    </div>
    <div class="log-metadata-category">
      <div class="badge automation-background" *ngIf="isAutomationRule(log)" style="margin-left: 4px">Automation Action</div>
    </div>
    <div class="log-metadata-category">
      <ng-container *ngFor="let list of log.eventCodeList">
        <div class="badge xml-code">{{ list.code }}</div>
      </ng-container>
    </div>
    <div class="log-metadata-device"> 
      <div class="log-metadata-device-name" [class.no-name]="!log.name">{{log.name ?? 'No Name'}}</div>
    </div>
    <div class="log-metadata-other">{{capitalizeFirstLetter(log.status_text)}}</div>
    <div class="log-metadata-other" *ngIf="log?.partnerDescription">{{ log?.partnerDescription }}</div>
  </div>
</ng-container>